import React from 'react';
import { HeroSection } from './HeroSection';
import { StatisticsSection } from './StatisticsSection';
import { MarketplaceSection } from './MarketplaceSection';
import { NewsletterFooter } from './NewsletterFooter';
import { RevenueBenefits } from './RevenueBenefits';
import FeaturesSection from './FeaturesSection';
import EcoFriendlySection from './EcoFriendlySection';
import BrandFeatures from './BrandFeatures';
import TaxBenefits from './TaxBenefits';
import RequestToSell from './RequestToSell';

export default function LandingPage() {
  return (
    <div className="tw-flex tw-flex-col tw-bg-white">
      <main>
        <HeroSection />
        <StatisticsSection />
        <MarketplaceSection />
        <FeaturesSection />
        <RevenueBenefits />
        <EcoFriendlySection />
        <BrandFeatures />
        <TaxBenefits />
        <RequestToSell />
      </main>
      <NewsletterFooter />
    </div>
  );
}

